export const getPartnerSubscriptionPrice = (
  price: number,
  partnerDiscountRate: number
): number => Math.round(price * 100 * (1 - partnerDiscountRate / 100)) / 100;

export const getBillingDisplayPrices = (
  price: number,
  isPartnerPayment: boolean,
  partnerDiscountRate?: number
) => {
  const totalPrice = isPartnerPayment && partnerDiscountRate !== undefined
    ? getPartnerSubscriptionPrice(price, partnerDiscountRate)
    : price;

  return {
    totalPrice,
    originalPrice:
      isPartnerPayment && totalPrice < price ? price : undefined,
  };
};
